import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BypassInterceptorContext } from '../interceptors/http.interceptor';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
    private allNotifications$?: Observable<any[]>;
  
    constructor(private http: HttpClient) {}
  
    private fetchNotifications(): Observable<any[]> {
      if (!this.allNotifications$) {
        const baseUrl = environment.SWITCH_URL;
        const endPoint = '/user/api/v1/user/global-notification';
        const apiUrl = baseUrl + endPoint;
  
        const token = localStorage.getItem('auth-token') || '';
        const headers = new HttpHeaders({
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        });
  
        const context = new HttpContext().set(BypassInterceptorContext, true);
        const dismissed = JSON.parse(localStorage.getItem('dismissedOneTimeBanners') || '[]');
  
        this.allNotifications$ = this.http.get(apiUrl, { headers, context }).pipe(
          map((res: any) =>
            res.data.map((item: any) => {
              let isVisible = true;
              if (item.type === 'banner') {
                if (!item.is_reccurring && dismissed.includes(item.id)) {
                  isVisible = false;
                }
              }
  
              return {
                ...item,
                isVisible,
              };
            })
          ),
          shareReplay(1)
        );
      }
  
      return this.allNotifications$;
    }
  
    getBanners(): Observable<any[]> {
      return this.fetchNotifications().pipe(
        map((items) => items.filter((item) => item.type === 'banner' && item.isVisible))
      );
    }
  
    getMessages(): Observable<any[]> {
      return this.fetchNotifications().pipe(
        map((items) => items.filter((item) => item.type === 'message' && item.isVisible))
      );
    }
  
    resetNotificationCache() {
      this.allNotifications$ = undefined;
    }
  }
